(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var SIZE_FIELDSET_SELECTOR = 'fieldset[data-option-role="size"]';

    function clearSizeSelection(fieldset) {
      fieldset.querySelectorAll('input[data-option-position]:checked').forEach(function (input) {
        input.checked = false;
      });
      fieldset.querySelectorAll('[data-selected-value-text]').forEach(function (el) {
        el.textContent = '';
      });

      // Keep the sticky bar's size trigger (a separate, hand-rolled UI — see
      // snippets/product-sticky-add-to-cart.liquid) in sync: it's server-rendered
      // from the same auto-selected variant this function is undoing client-side,
      // so without this it kept showing a size while the main picker went blank.
      // Shows the same translated "Select" placeholder the snippet itself falls
      // back to server-side (data-select-label on <product-sticky-add-to-cart>),
      // not a blank string — unlike the main picker's inline span above, this
      // one always has a label ("Size: ___"), so leaving it blank read as broken.
      var stickyBar = document.querySelector('product-sticky-add-to-cart');
      var stickySelectLabel = stickyBar && stickyBar.dataset.selectLabel;
      document.querySelectorAll('[data-sbb-size-value]').forEach(function (el) {
        el.textContent = stickySelectLabel || '';
      });
      document.querySelectorAll('[data-sbb-size-btn]').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
      });
    }

    // Both the main buy-buttons ATC and the sticky bar's own ATC submit the
    // same form (the sticky one via the HTML `form=""` attribute rather than
    // being nested inside it) — kept in sync as a pair everywhere below so
    // messaging (this placeholder) and click-blocking (the submit listener
    // further down, which already applies at the form level) behave the same
    // on both. `[type="submit"]` naturally excludes the sticky button while
    // it's in its Notify Me state (type="button" there) — see
    // snippets/product-sticky-add-to-cart.liquid.
    function getSubmitButtons(form) {
      var formId = CSS.escape(form.getAttribute('id'));
      var buttons = [];

      var buyButtons = document.querySelector('buy-buttons[form="' + formId + '"]');
      var mainButton = buyButtons && buyButtons.querySelector('button[type="submit"]');
      if (mainButton) buttons.push(mainButton);

      var stickyButton = document.querySelector('.sbb__atc[type="submit"][form="' + formId + '"]');
      if (stickyButton) buttons.push(stickyButton);

      return buttons;
    }

    function getPlaceholderLabel(form) {
      var buyButtons = document.querySelector('buy-buttons[form="' + CSS.escape(form.getAttribute('id')) + '"]');
      return buyButtons && buyButtons.getAttribute('data-select-size-label');
    }

    // Same content fade/slide used by <button-content>'s own add-to-cart
    // loading transition (js/common/typography/button.js in theme.js) —
    // translateY(10px)<->translateY(0) with an opacity fade, 180ms.
    var TEXT_SWAP_DURATION = 180;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setContentText(content, label) {
      content.textContent = label;

      if (content.hasAttribute('up-text')) {
        content.setAttribute('up-text', label);
      }

      if (content.hasAttribute('rotated-text')) {
        content.setAttribute('rotated-text', label);
      }
    }

    function animateContentTextChange(content, label) {
      if (prefersReducedMotion || !content.animate) {
        setContentText(content, label);
        return;
      }

      var out = content.animate(
        [
          { transform: 'translateY(0)', opacity: 1 },
          { transform: 'translateY(-10px)', opacity: 0 }
        ],
        { duration: TEXT_SWAP_DURATION, easing: 'ease', fill: 'forwards' }
      );

      out.onfinish = function () {
        out.cancel(); // release the fill:'forwards' hold before handing off to `into`
        setContentText(content, label);

        var into = content.animate(
          [
            { transform: 'translateY(10px)', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ],
          { duration: TEXT_SWAP_DURATION, easing: 'ease' }
        );

        into.onfinish = function () {
          into.cancel();
        };
      };
    }

    function setButtonPlaceholder(form, showPlaceholder) {
      var placeholderLabel = getPlaceholderLabel(form);

      getSubmitButtons(form).forEach(function (button) {
        if (button.disabled) return;

        var content = button.querySelector('button-content') || button;

        if (showPlaceholder) {
          if (!button.dataset.originalLabel) {
            button.dataset.originalLabel = content.textContent.trim();
          }

          if (placeholderLabel) {
            animateContentTextChange(content, placeholderLabel);
          }
        } else if (button.dataset.originalLabel) {
          animateContentTextChange(content, button.dataset.originalLabel);
          delete button.dataset.originalLabel;
        }
      });
    }

    function clearInitialSizeSelection(fieldset) {
      var picker = fieldset.closest('variant-picker');
      var formId = picker && picker.getAttribute('form-id');
      var form = formId && document.forms[formId];

      if (new URLSearchParams(window.location.search).has('variant')) {
        return;
      }

      clearSizeSelection(fieldset);

      if (form) {
        form.id.value = '';
      }
    }

    document.querySelectorAll(SIZE_FIELDSET_SELECTOR).forEach(clearInitialSizeSelection);

    document.addEventListener('change', function (event) {
      var input = event.target;

      if (!input.matches || !input.matches('input[data-option-position]')) {
        return;
      }

      var fieldset = input.closest(SIZE_FIELDSET_SELECTOR);

      if (!fieldset || !input.form) {
        return;
      }

      input.form.dataset.sizeChosen = 'true';
      setButtonPlaceholder(input.form, false);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement) || form.getAttribute('action') === null || form.getAttribute('action').indexOf('/cart/add') === -1) {
        return;
      }

      var picker = document.querySelector('variant-picker[form-id="' + CSS.escape(form.getAttribute('id')) + '"]');
      var fieldset = picker && picker.querySelector(SIZE_FIELDSET_SELECTOR);

      if (!fieldset) {
        return;
      }

      var hasSizeSelected = !!fieldset.querySelector('input[data-option-position]:checked');

      if (!hasSizeSelected) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setButtonPlaceholder(form, true);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
